import React, { type ImgHTMLAttributes } from 'react';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
    loading?: 'lazy' | 'eager';
    testId?: string;
    extraClass?: string;
}

/**
 *
 * Image Component:
 * A reusable Image component
 */
const ImageWidget: React.FC<ImageProps> = ({
    loading = 'lazy',
    src,
    alt,
    width,
    height,
    testId,
    extraClass,
    ...restProps
}: ImageProps) => {
    return (
        <img className={extraClass} {...restProps} src={src} alt={alt} width={width} height={height} loading={loading} data-testid={testId} />
    );
};

export default ImageWidget;
